import { createSlider } from "../../../../assets/js/slider.js";

function initExpertiseSlider() {
	document.querySelectorAll(".expertise_slider-layout").forEach((layout) => createSlider(layout, ".expertise-swiper"));
}

if (document.readyState === "loading") {
	document.addEventListener("DOMContentLoaded", initExpertiseSlider);
} else {
	initExpertiseSlider();
}
